import { render, staticRenderFns } from "./EditContractEdutalkNewVersion.vue?vue&type=template&id=51ed80dc"
import script from "./EditContractEdutalkNewVersion.vue?vue&type=script&lang=js"
export * from "./EditContractEdutalkNewVersion.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./EditContractEdutalkNewVersion.vue?vue&type=style&index=1&id=51ed80dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports